export default "__VITE_ASSET__DxudU7NQ__"